import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SageFix } from '../../../../shared/services/sage-integration.model';

/** One problem; the ids are kept for the fixes that act on a record. */
export interface ErrorRecordRow {
  /** The error row's id. */
  id: number;
  name: string;
  detail: string;
  recordId: string | null;
  aivorRecordId: number | null;
  entityType: string;
  errorCode: string;
}

export interface ErrorGroup {
  code: string;
  label: string;
  entityPill: string;
  whatToDo: string;
  /** The column button's label; null for "See what to do". */
  action: string | null;
  fix: SageFix | null;
  /** How the problem clears, by kind. */
  clears: string;
  count: number;
  records: ErrorRecordRow[];
  /** Set by the console once the open reason has gone from the list. */
  fixed?: boolean;
}

@Component({
  selector: 'app-sage-errors-column',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './errors-column.component.html',
  styleUrls: ['./sage-work-column.css'],
})
export class SageErrorsColumnComponent {
  @Input() groups: ErrorGroup[] = [];
  @Input() retryingCount = 0;
  @Input() loading = false;

  @Output() openIssues = new EventEmitter<void>();
  @Output() fixGroup = new EventEmitter<ErrorGroup>();

  showAllGroups = false;

  private readonly VISIBLE_GROUPS = 5;

  readonly trackGroup = (_: number, g: ErrorGroup) => g.code;

  get visibleGroups(): ErrorGroup[] {
    return this.showAllGroups ? this.groups : this.groups.slice(0, this.VISIBLE_GROUPS);
  }

  get hiddenGroupCount(): number {
    return Math.max(0, this.groups.length - this.VISIBLE_GROUPS);
  }
}
